export const PIE_VALUE = 1;

export const DEFAULT_SERIE_NAME = 'values';
export const DEFAULT_LABEL_NAME = 'label';

export const ARC_STATES = {
  NORMAL: 'NORMAL',
  ACTION_HOVER: 'ACTION_HOVER',
  ACTION_NO_HOVER: 'ACTION_NO_HOVER',
};
